import { Box, VStack } from '@bpba/ui-components';
import { ModuleContainerGeneric, SvgData } from '@bpba/modules-components';
import { Copyright } from './Copyright';
import { Sellos1, Sellos2 } from './Sellos';
import { Redes } from './Redes';
import { IconosGrandes } from '@bpba/modules-components';
import { FOOTER_DATA } from '../../constants/data';

export const Footer = () => {
  return (
    <>
      <IconosGrandes
        data={FOOTER_DATA.ICONOS_GRANDES.map((item) => {
          return SvgData.fromJsonObject(item);
        })}
        orden={0}
      />
      <ModuleContainerGeneric backgroundColor={'secondary.1'} paddingBottom={['50px !important']}>
        <VStack color={'white'}>
          <Box flexDirection={['column', null, null, 'row']}>
            <Box
              width="100%"
              display="flex"
              flexDirection={['column', 'row']}
              alignItems={['center', 'unset']}
              marginBottom={[0, 50, null, 0]}
            >
              <Redes />
              <Sellos1 />
            </Box>
            <Sellos2 />
          </Box>
          <Copyright />
        </VStack>
      </ModuleContainerGeneric>
    </>
  );
};
